<script lang="ts">
    import { twMerge } from "tailwind-merge"

    let className = ""
    export { className as class }
</script>

<div
    class={twMerge(
        "w-full h-full flex items-center flex-col justify-center text-center",
        className,
    )}
>
    <slot />
</div>
